export default __webpack_public_path__ + "static/zap-list-gif-05069d5f086545d1dccf80c59a0c667d.mp4";